<template>
  <div class="home">
  
    <Reproductor msg="Los colores" audio2="../mp3/PrimariaA/05PA.mp3" cover="../img/1.jpg" name="Primaria A - Lección #5"/>
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA5',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
